import React__default from 'react';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes__default from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';

var useStyles = makeStyles(function (theme) {
  return {
    inlineBlock: {
      display: "inline-block"
    },
    testing: {
      marginLeft: theme.spacing(1.75),
      color: theme.palette.grey["400"]
    }
  };
});
var AdminLAbelButton = withStyles(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.secondary["A400"],
      "&:hover": {
        backgroundColor: theme.palette.secondary["A400"]
      },
      paddingTop: theme.spacing(1.25),
      pointerEvents: "none",
      fontSize: 18,
      fontFamily: "Josefin Sans",
      fontWeight: 700,
      color: theme.palette.secondary["900"],
      width: 88,
      height: 34
    }
  };
})(Button);
var AdminButton = function AdminButton(_ref) {
  var testing = _ref.testing,
    classname = _ref.classname;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Grid, {
    className: classname,
    container: true,
    direction: "row",
    justify: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(AdminLAbelButton, {
    variant: "contained",
    color: "primary"
  }, "ADMIN")), testing && /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    className: clsx(classes.inlineBlock, classes.testing)
  }, "Testing"))));
};
AdminButton.defaultProps = {
  testing: true
};
AdminButton.propTypes = {
  testing: PropTypes__default.bool,
  classname: PropTypes__default.string
};

export { AdminButton as default };
//# sourceMappingURL=AdminButton.js.map
